import React from "react";
import PinOtpComponent from "./PinOtpComponent";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";

const Authentication = () => {
  const user = useReadMemory(MemoryType.USER);

  return (
    <>
      <PinOtpComponent user={user} />
    </>
  );
};

export default Authentication;
